import D3BarVerticalStacked from './d3BarVerticalStacked'
export default D3BarVerticalStacked
